import { CredenciaisPayLoad } from "@cei-ufg/ngx-cei-sso-client";

export const credenciaisMapper: CredenciaisPayLoad = (customPayload: any) => {
    // Retorna o objeto formatado que o backend espera
    return {
        login: customPayload.usuario, // Mapeia o campo 'login' do payload customizado conforme configurado no backend django
        password: customPayload.senha // Mapeia o campo 'password' do payload customizado conforme configurado no backend django
    };
};